import editIcon from './svg/edit.svg?raw';
import arrowRightIcon from './svg/arrow-right.svg?raw';
import simulateTradingIcon from './svg/simulate-trading.svg?raw';
import tradingBotsIcon from './svg/trading-bots.svg?raw';
import adjustIcon from './svg/adjust.svg?raw';
import googleIcon from './svg/google.svg?raw';
import lockIcon from './svg/lock.svg?raw';
import keyIcon from './svg/key.svg?raw';
import passkeysIcon from './svg/passkeys.svg?raw';
import emailIcon from './svg/email.svg?raw';
import telegramIcon from './svg/telegram.svg?raw';
import authorizationIcon from './svg/authorization.svg?raw';
import antiPhishingCodeIcon from './svg/anti-phishing-code.svg?raw';
import whitelistIcon from './svg/whitelist.svg?raw';
import deviceIcon from './svg/device.svg?raw';
import accountDeleteIcon from './svg/account-delete.svg?raw';
import adjustColorIcon from './svg/adjust-color.svg?raw';
import chartColorIcon from './svg/chart-color.svg?raw';
import computerColorIcon from './svg/computer-color.svg?raw';
import earthColorIcon from './svg/earth-color.svg?raw';
import heartColorIcon from './svg/heart-color.svg?raw';
import securityColorIcon from './svg/security-color.svg?raw';
import shareIcon from './svg/share.svg?raw';
import levelColorIcon from './svg/level-color.svg?raw';
import smoothColorIcon from './svg/smooth-color.svg?raw';
import commissionColorIcon from './svg/commission-color.svg?raw';
import arrowUpIcon from './svg/arrow-up.svg?raw';
import arrowDownIcon from './svg/arrow-down.svg?raw';
import longRightIcon from './svg/long-right.svg?raw';
import dashboardIcon from './svg/dashboard.svg?raw';
import walletIcon from './svg/wallet.svg?raw';
import quedtionCircleFilledIcon from './svg/question-circle-filled.svg?raw';
import LinkIcon from './svg/link.svg?raw';
import transferIcon from './svg/transfer.svg?raw';
import circleHookIcon from './svg/circle-hook.svg?raw';
import addIcon from './svg/add.svg?raw';
import noticeIcon from './svg/notice.svg?raw';
import settingIcon from './svg/setting.svg?raw';
import arrowLeftIcon from './svg/arrow-left.svg?raw';

// Outlined
import checkOutlined from './svg/checkOutlined.svg?raw';
import copyOutlined from './svg/copyOutlined.svg?raw';
import noteOutlined from './svg/noteOutlined.svg?raw';
import faqOutlined from './svg/faqOutlined.svg?raw';
import addressOutlined from './svg/addressOutlined.svg?raw';
import checkSquareOutlined from './svg/checkSquareOutlined.svg?raw';
import uncheckSquareOutlined from './svg/uncheckSquareOutlined.svg?raw';
import positionOutlined from './svg/positionOutlined.svg?raw';
import addCircleOutlined from './svg/addCircleOutlined.svg?raw';
import minusCircleOutlined from './svg/minusCircleOutlined.svg?raw';
import starOutlined from './svg/starOutlined.svg?raw';
import heartOutlined from './svg/heartOutlined.svg?raw';
import shareOutlined from './svg/shareOutlined.svg?raw';
import converterOutlined from './svg/converterOutlined.svg?raw';
import eyeOpenOutlined from './svg/eyeOpenOutlined.svg?raw';
import eyeCloseOutlined from './svg/eyeCloseOutlined.svg?raw';
import searchOutlined from './svg/searchOutlined.svg?raw';
import orderOutlined from './svg/orderOutlined.svg?raw';
import infoCircleOutlined from './svg/infoCircleOutlined.svg?raw';
import closeOutlined from './svg/closeOutlined.svg?raw';

// Filled
import selectDownFilled from './svg/selectDownFilled.svg?raw';
import selectUpFilled from './svg/selectUpFilled.svg?raw';
import exclamationCircleFilled from './svg/exclamationCircleFilled.svg?raw';
import infoCircleFilled from './svg/infoCircleFilled.svg?raw';
import starFilled from './svg/starFilled.svg?raw';
import checkSquareFilled from './svg/checkSquareFilled.svg?raw';
import heartFilled from './svg/heartFilled.svg?raw';
import checkCircleFilled from './svg/checkCircleFilled.svg?raw';

export const svgMap = {
  edit: editIcon,
  arrowRight: arrowRightIcon,
  simulateTrading: simulateTradingIcon,
  tradingBots: tradingBotsIcon,
  adjust: adjustIcon,
  google: googleIcon,
  lock: lockIcon,
  key: keyIcon,
  passkeys: passkeysIcon,
  email: emailIcon,
  telegram: telegramIcon,
  authorization: authorizationIcon,
  antiPhishingCode: antiPhishingCodeIcon,
  whitelist: whitelistIcon,
  device: deviceIcon,
  accountDelete: accountDeleteIcon,
  adjustColor: adjustColorIcon,
  chartColor: chartColorIcon,
  computerColor: computerColorIcon,
  earthColor: earthColorIcon,
  heartColor: heartColorIcon,
  securityColor: securityColorIcon,
  share: shareIcon,
  levelColor: levelColorIcon,
  smoothColor: smoothColorIcon,
  commissionColor: commissionColorIcon,
  arrowUp: arrowUpIcon,
  arrowDown: arrowDownIcon,
  longRight: longRightIcon,
  dashboard: dashboardIcon,
  wallet: walletIcon,
  quedtionCircleFilled: quedtionCircleFilledIcon,
  link: LinkIcon,
  transfer: transferIcon,
  circleHook: circleHookIcon,
  add: addIcon,
  notice: noticeIcon,
  setting: settingIcon,
  arrowLeft: arrowLeftIcon,

  // Outlined
  checkOutlined,
  copyOutlined,
  noteOutlined,
  faqOutlined,
  addressOutlined,
  checkSquareOutlined,
  uncheckSquareOutlined,
  positionOutlined,
  addCircleOutlined,
  minusCircleOutlined,
  starOutlined,
  heartOutlined,
  shareOutlined,
  converterOutlined,
  eyeOpenOutlined,
  eyeCloseOutlined,
  searchOutlined,
  orderOutlined,
  infoCircleOutlined,
  closeOutlined,

  // Filled
  exclamationCircleFilled,
  infoCircleFilled,
  selectDownFilled,
  selectUpFilled,
  starFilled,
  checkSquareFilled,
  heartFilled,
  checkCircleFilled,
};
